/** Every query key starts with the workspace, so switching account can never show another account's data. */
export const scopedKey = (workspaceId: number | null, ...parts: unknown[]): unknown[] => ["ws", workspaceId, ...parts];
